/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceGalleryImage } from './SurfaceGalleryImage';
import {
    SurfaceGalleryImageFromJSON,
    SurfaceGalleryImageFromJSONTyped,
    SurfaceGalleryImageToJSON,
    SurfaceGalleryImageToJSONTyped,
} from './SurfaceGalleryImage';

/**
 * 
 * @export
 * @interface SurfaceImageGalleryConfig
 */
export interface SurfaceImageGalleryConfig {
    /**
     * 
     * @type {Array<SurfaceGalleryImage>}
     * @memberof SurfaceImageGalleryConfig
     */
    images?: Array<SurfaceGalleryImage>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceImageGalleryConfig
     */
    layout?: SurfaceImageGalleryConfigLayoutEnum;
    /**
     * 
     * @type {number}
     * @memberof SurfaceImageGalleryConfig
     */
    columns?: number;
}


/**
 * @export
 */
export const SurfaceImageGalleryConfigLayoutEnum = {
    carousel: 'carousel',
    grid: 'grid'
} as const;
export type SurfaceImageGalleryConfigLayoutEnum = typeof SurfaceImageGalleryConfigLayoutEnum[keyof typeof SurfaceImageGalleryConfigLayoutEnum];


/**
 * Check if a given object implements the SurfaceImageGalleryConfig interface.
 */
export function instanceOfSurfaceImageGalleryConfig(value: object): value is SurfaceImageGalleryConfig {
    return true;
}

export function SurfaceImageGalleryConfigFromJSON(json: any): SurfaceImageGalleryConfig {
    return SurfaceImageGalleryConfigFromJSONTyped(json, false);
}

export function SurfaceImageGalleryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceImageGalleryConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(SurfaceGalleryImageFromJSON)),
        'layout': json['layout'] == null ? undefined : json['layout'],
        'columns': json['columns'] == null ? undefined : json['columns'],
    };
}

export function SurfaceImageGalleryConfigToJSON(json: any): SurfaceImageGalleryConfig {
    return SurfaceImageGalleryConfigToJSONTyped(json, false);
}

export function SurfaceImageGalleryConfigToJSONTyped(value?: SurfaceImageGalleryConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(SurfaceGalleryImageToJSON)),
        'layout': value['layout'],
        'columns': value['columns'],
    };
}

